/**
 * @file Constants — a1EmbodiedEnergyFactors.
 * A1 embodied energy — petrol / diesel conversion (MJ-equivalent path → kWh).
 * Admin-configurable backend value will replace this later.
 */

export const A1_PETROL_DIESEL_EMBODIED_ENERGY_CONVERSION_FACTOR = 0.278;
